import React from 'react'
import styled from '@emotion/styled'
import { TelLinkList } from './TelLinkList'
import { usePinMarkImg } from '../../../utils/usePinMarkImg'

const formatDate = (dateStr: string) => {
  const d = new Date(dateStr)
  return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`
}

export const InfoWindowItemNormal = ({ info, showModal }: any) => {
  const { src, onError } = usePinMarkImg(info.pin_id)

  return (
    <InfoWindowLi>
      <InfoWindowLiImg src={src} alt="" onError={onError} />
      <IndoWindowLiBox>
        <InfoWindowLiTitle>{info.title}</InfoWindowLiTitle>
        <InfoWindowLiTxt>
          <InfoWindowLiTxtBold>業態：</InfoWindowLiTxtBold>
          {info.category_id}
        </InfoWindowLiTxt>

        <InfoWindowLiTxt>
          <InfoWindowLiTxtBold>獲得済み商材：</InfoWindowLiTxtBold>
          {info.kakutoku ? info.kakutoku : '-'}
        </InfoWindowLiTxt>

        <InfoWindowLiTxt>
          <InfoWindowLiTxtBold>電話番号：</InfoWindowLiTxtBold>
          <TelLinkList tel={info.tel} />
        </InfoWindowLiTxt>
        {info.representative ? (
          <InfoWindowLiTxt>
            <InfoWindowLiTxtBold>代表者：</InfoWindowLiTxtBold>
            {info.representative}
          </InfoWindowLiTxt>
        ) : null}
        {info.contact ? (
          <InfoWindowLiTxt>
            <InfoWindowLiTxtBold>担当者：</InfoWindowLiTxtBold>
            {info.contact}
          </InfoWindowLiTxt>
        ) : null}
        {info.completed_on ? (
          <InfoWindowLiTxt>
            <InfoWindowLiTxtBold>完了日：</InfoWindowLiTxtBold>
            {formatDate(info.completed_on)}
          </InfoWindowLiTxt>
        ) : null}
      </IndoWindowLiBox>
      <InfoWindowLiBtn onClick={() => showModal(info)}>詳細</InfoWindowLiBtn>
    </InfoWindowLi>
  )
}

const InfoWindowLi = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  margin: 0 20px;
  border-bottom: solid 1px #cccccc;
  // text-overflow: ellipsis;
  // white-space: nowrap;
  // overflow: hidden;
  &:last-child {
    border-bottom: none;
  }
  @media (min-width: 450px) {
    margin: 0 30px;
  }
`

const InfoWindowLiImg = styled.img`
  height: auto;
  width: 20px;
`

const InfoWindowLiTitle = styled.p`
  font-size: 16px;
  padding-bottom: 5px;
  color: #4d4d4d;
  &:first-of-type {
    color: #333333;
    font-weight: bold;
    letter-spacing: 0.5px;
  }
`
const InfoWindowLiTxt = styled.div`
  // overflow: hidden;
  // white-space: nowrap;
  // text-overflow: ellipsis;
  padding-bottom: 5px;
  color: #4d4d4d;
  font-size: 14px;
  &:first-of-type {
    color: #333333;
    font-weight: bold;
    letter-spacing: 0.5px;
  }
`

const InfoWindowLiTxtBold = styled.span`
  font-weight: bold;
`

const IndoWindowLiBox = styled.div`
  // max-width: 170px;
  width: 170px;
  @media (min-width: 450px) {
    width: 70%;
  }
`

const InfoWindowLiBtn = styled.button`
  font-family: inherit;
  cursor: pointer;
  font-size: 14px;
  padding: 3px 15px;
  border-radius: 20px;
  border: none;
  background: #0e2851;
  color: #ffffff;
  outline: none;
`
